import {
  syncAPI,
  getComplianceInventoryRoomsAPI,
  getComplianceNalTaxOnlyAPI,
  getStateCannabisDefinition,
  limitV2ConfigAPI,
} from '../api/compliance'

import { addMessageCurry } from '../utils/api'
import { SAVE_FLAG_NAL_TAXES_ONLY } from '../types/shop'

export const saveFlagNalTaxesOnly = (payload) => ({
  type: SAVE_FLAG_NAL_TAXES_ONLY,
  payload,
})

export const complianceSync = (types) => (dispatch) => addMessageCurry(syncAPI(types), dispatch)

export const getComplianceInventoryRooms = (_) => {
  return (dispatch) => {
    return new Promise((resolve, _) => {
      addMessageCurry(getComplianceInventoryRoomsAPI(), dispatch).then((res) => {
        resolve(res)
        return res
      })
    })
  }
}

export const checkIfNalTaxesOnlyFlagIsEnabled = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getComplianceNalTaxOnlyAPI(), dispatch)
        .then((res) => {
          dispatch(saveFlagNalTaxesOnly({ flagisNalTaxesOnly: res.resultTaxesOnly }))
          resolve(res)
        })
        .catch((err) => reject(err))
    })
  }
}

export const getStateCannabisDefinitionActions = (company, useDefaultCategoryName = false) => {
  const { address = {} } = company || {}
  const { state = '' } = address || {}
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getStateCannabisDefinition({ state, type: 'STATE_TYPE' }), dispatch)
        .then((res) => {
          let cannabisTypes = {}
          if (res.allowedCannabisTypes && res.allowedCannabisTypes.length > 0) {
            cannabisTypes['DEFAULT'] = useDefaultCategoryName ? 'Inherit from Category' : 'Default'
            res.allowedCannabisTypes.forEach((item) => {
              cannabisTypes[item.cannabisType] = item.displayName
            })
          }
          resolve(cannabisTypes)
        })
        .catch((err) => reject(err))
    })
  }
}

export const limitV2Config = (state) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      limitV2ConfigAPI(state)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => reject(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/compliance.js